import { Image as ImageComponent } from '@heroui/react';
import { useEffect, useState } from 'react';

export const LazyImage = (props: {
  src?: string;
  fit?: 'contain' | 'cover';
}) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (props.src) {
      const img = new Image();
      img.onload = () => {
        setSrc(props.src!);
      };
      img.src = props.src;
    }
  }, [props.src]);

  const fit = props.fit === 'contain' ? 'object-contain' : 'object-cover';

  return (
    <ImageComponent
      isLoading={!props.src || !src}
      loading="eager"
      radius="md"
      width="100%"
      height="100%"
      classNames={{
        img: `z-0 ${fit}`,
        wrapper: 'z-0 h-full w-full',
      }}
      src={src || props.src || '/'}
    />
  );
};
